<section class="feature-page">
  <app-page-header
    title="Tipos de Servicios Divinos"
    subtitle="Gestiona todos los tipos de servicios disponibles"
    icon="church">
  </app-page-header>

  <div class="feature-page__content">
    <mat-card class="table-surface-card">
      <mat-card-content>
        <app-table-surface
            [columns]="columns"
            [data]="tableData"
            [isLoading]="isLoading"
            [enableDragDrop]="isDragDropEnabled"
            [cellTemplate]="cellContent"
            [savingCell]="savingCell"
            tableId="divine-service-type-list"
            [enableSearch]="true"
            searchPlaceholder="Buscar tipo de servicio..."
            [enableColumnVisibility]="true"
            [enableDensity]="true"
            primaryActionLabel="Nuevo"
            (searchChange)="onToolbarSearch($event)"
            (rowReorder)="onRowsReordered($event)"
            (cellEditSave)="onCellEditSave($event)"
            (primaryActionClick)="createNew()">
          </app-table-surface>

        <ng-template #cellContent let-column="column" let-row="row">
          <span *ngIf="column === 'name'">{{ row.name }}</span>
          <span *ngIf="column === 'displayName'">{{ row.displayName }}</span>

          <div *ngIf="column === 'actions'" class="actions-cell">
            <button mat-icon-button matTooltip="Editar" (click)="$event.stopPropagation(); editType(row)">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button matTooltip="Eliminar" (click)="$event.stopPropagation(); deleteType(row)">
              <mat-icon color="warn">delete</mat-icon>
            </button>
          </div>
        </ng-template>
      </mat-card-content>
    </mat-card>
  </div>
</section>
